<template>
    <div class="patrol_task_container">
        <!--searchCont头部-->
        <el-form :inline="true" class="leader-style-form">
            <el-form-item label="巡检负责人">
                <el-input
                    maxlength="50"
                    v-model="searchForm.leader_id_name"
                    autocomplete="off"
                    clearable="true"
                ></el-input>
            </el-form-item>

            <el-form-item label="巡检状态">
                <el-select v-model="searchForm.inspection_task_state">
                    <el-option label="全部" value></el-option>
                    <el-option label="待巡检" value="10"></el-option>
                    <el-option label="已巡检" value="20"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="巡检时间">
                <el-date-picker
                    v-model="searchForm.plan_inspection_time_range"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                ></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="warning" @click="doSearch()">查询</el-button>
            </el-form-item>
        </el-form>

        <!-- 任务列表 -->
        <div class="table-wrap">
            <el-table border :data="tableJson" class="leader-style-table">
                <el-table-column type="index" width="50" align="center" label="序号" property="num"></el-table-column>
                <el-table-column
                    label="巡检单号"
                    property="inspection_task_no"
                    align="center"
                    width="250px"
                ></el-table-column>
                <el-table-column label="巡检任务负责人" property="leader_id_name" align="center"></el-table-column>
                <el-table-column label="巡检人员" property="worker_names" align="center"></el-table-column>
                <el-table-column label="巡检设备数量" property="tree_count" align="center"></el-table-column>
                <el-table-column label="巡检类型" property="inspection_plan_type_name" align="center"></el-table-column>
                <el-table-column label="本次登记缺陷" property="is_normal_count" align="center"></el-table-column>
                <el-table-column
                    label="巡检时间"
                    property="plan_inspection_time"
                    align="center"
                    width="200px"
                ></el-table-column>
                <el-table-column label="巡检状态" property="inspection_task_state_name" align="center"></el-table-column>
                <el-table-column label="修改" width="300" align="center">
                    <template slot-scope="scope">
                        <el-button
                            @click="doQuexian(scope.row)"
                            type="text"
                            class="button-delete"
                            v-pms="'btn_patrol_task_defect'"
                        >
                            <i class="iconfont iconeditor"></i>
                            缺陷
                            <!-- <span class="inner-text"></span> -->
                        </el-button>
                        <el-button
                            @click="doRecord(scope.row)"
                            type="text"
                            class="button-check"
                            v-pms="'btn_patrol_task_record'"
                        >
                            <i class="iconfont iconeditor"></i>
                            记录
                            <!-- <span class="inner-text"></span> -->
                        </el-button>
                        <el-button
                            @click="doYanqi(scope.row)"
                            type="text"
                            class="button-modify"
                            v-pms="'btn_patrol_task_putoff'"
                        >
                            <i class="iconfont iconyanqi"></i>
                            延期
                            <!-- <span class="inner-text"></span> -->
                        </el-button>
                        <el-button
                            @click="doDistribute(scope.row)"
                            type="text"
                            class="button-check"
                            v-pms="'btn_patrol_task_distribute'"
                        >
                            <i class="iconfont iconic_assign"></i>
                            分配
                            <!-- <span class="inner-text"></span> -->
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination
                class="leader-style-pagination"
                :paginationData="paginationData"
                @paginationDataNew="paginationDataNew"
                v-if="this.paginationData.totalNum"
            ></Pagination>
            <AddDefentDialog :defentDialogVisible.sync="defentDialogVisible" class="leader-dialog"></AddDefentDialog>
        </div>
        <!-- 巡检记录修改页面 -->
        <el-dialog
            class="leader-dialog"
            title="巡检记录"
            width="1000px"
            :visible.sync="recordshow"
            :close-on-click-modal="false"
        >
            <el-scrollbar style="height: 480px">
                <el-form
                    class="leader-style-form"
                    :rules="formRules"
                    :model="recordForm"
                    ref="recordForm"
                    :show-message="false"
                >
                    <el-row :gutter="20">
                        <!-- <el-col :span="8">
                            <el-form-item
                                label="巡检地点"
                                :label-width="formLabelWidth"
                                prop="inspection_place"
                            >
                                {{ recordForm.inspection_place }}
                            </el-form-item>
                        </el-col>-->
                        <el-col :span="12">
                            <el-form-item
                                label="巡检任务负责人"
                                :label-width="formLabelWidth"
                                prop="leader_id"
                            >
                                <el-input
                                    type="input"
                                    v-model="recordForm.leader_id_name"
                                    :disabled="true"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                label="巡检人员"
                                :label-width="formLabelWidth"
                                prop="worker_ids"
                            >
                                <el-input
                                    type="input"
                                    v-model="recordForm.worker_names"
                                    :disabled="true"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                label="巡检开始时间"
                                :label-width="formLabelWidth"
                                prop="inspection_time_start"
                            >
                                <el-date-picker
                                    v-model="recordForm.inspection_time_start"
                                    align="right"
                                    type="datetime"
                                    style="width: 100%"
                                    :clearable="false"
                                    placeholder="选择日期"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    :picker-options="pickerOptions"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                label="巡检结束时间"
                                :label-width="formLabelWidth"
                                prop="inspection_time_end"
                            >
                                <el-date-picker
                                    v-model="recordForm.inspection_time_end"
                                    align="right"
                                    type="datetime"
                                    style="width: 100%"
                                    :clearable="false"
                                    placeholder="选择日期"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    :picker-options="pickerOptions"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="巡检结果"
                                :label-width="formLabelWidth"
                                style="width: 100%"
                                prop="inspection_result"
                            >
                                <el-input
                                    type="textarea"
                                    v-model="recordForm.inspection_result"
                                    resize="none"
                                    rows="5"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="patrol_record_title">本次需处理缺陷列表</div>
                <el-table border :data="tableData" style="width: 100%" class="leader-style-table">
                    <el-table-column prop="defect_no" width="130" label="缺陷单号"></el-table-column>
                    <el-table-column prop="tree_name" label="设备名称"></el-table-column>
                    <el-table-column prop="defect_level_name" label="缺陷性质"></el-table-column>
                    <el-table-column prop="defect_state_name" label="缺陷状态"></el-table-column>
                    <el-table-column prop="defect_source_name" label="缺陷来源"></el-table-column>
                    <el-table-column prop="founder" label="发现人"></el-table-column>
                    <el-table-column prop="solve_time_end" label="消缺完成时间"></el-table-column>
                    <el-table-column prop="dual_method_name" label="处理方式"></el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button
                                @click="deleteQx(scope.row)"
                                type="text"
                                class="button-delete"
                            >
                                <i class="iconfont iconashbin"></i>
                                删除
                                <!-- <span class="inner-text"></span> -->
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="patrol_record_title">巡检记录填写</div>
                <el-table
                    border
                    :data="tableJiluData"
                    style="width: 100%"
                    class="leader-style-table"
                >
                    <el-table-column prop="tree_name" label="巡检设备/项目"></el-table-column>
                    <el-table-column prop="is_normal_count" label="本次登记缺陷"></el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button
                                @click="doTypeRecord(scope.row)"
                                type="text"
                                class="button-modify"
                            >
                                <i class="iconfont iconeditor"></i>
                                填写
                                <!-- <span class="inner-text"></span> -->
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-scrollbar>
            <div slot="footer" class="dialog-footer">
                <el-button @click="recordshow = false" class="leader-common-button">取消</el-button>
                <el-button
                    class="leader-common-button"
                    @click="recordcommit('recordForm')"
                    :loading="this.$store.state.btnType"
                >保存</el-button>
            </div>
        </el-dialog>
        <!-- 巡检记录反馈填写 -->
        <el-dialog
            class="leader-dialog"
            title="巡检记录填写"
            width="1000px"
            :visible.sync="typeRecordShow"
            :close-on-click-modal="false"
        >
            <el-scrollbar style="height: 480px">
                <el-table
                    border
                    :data="typeRecordParam.typeInfoList"
                    :span-method="objectSpanMethod"
                    style="width: 100%; margin-top: 20px"
                    class="leader-style-table"
                >
                    <el-table-column prop="tree_name" label="巡检项目类别" width="180"></el-table-column>
                    <el-table-column prop="item_name" label="巡检项目"></el-table-column>
                    <el-table-column prop="item_content" width="300" label="巡检内容"></el-table-column>
                    <el-table-column prop="is_normal" label="是否正常">
                        <template scope="scope">
                            <el-select v-model="scope.row.is_normal" placeholder="请选择">
                                <el-option label="正常" value="0"></el-option>
                                <el-option label="不正常" value="1"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注">
                        <template scope="scope">
                            <el-input v-model="scope.row.remark"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </el-scrollbar>
            <div slot="footer" class="dialog-footer">
                <el-button @click="typeRecordShow = false" class="leader-common-button">取消</el-button>
                <el-button
                    @click="typeRecordCommit()"
                    type="primary"
                    class="leader-common-button"
                >保存</el-button>
            </div>
        </el-dialog>
        <!-- 重新分配 -->
        <el-dialog
            class="leader-dialog"
            title="任务分配"
            :visible.sync="distributeDialogVisible"
            :close-on-click-modal="false"
            width="800px"
        >
            <el-form
                class="leader-style-form"
                :rules="distributeFormRules"
                :model="distributeForm"
                ref="distributeForm"
                :show-message="false"
            >
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item
                            label="巡检任务负责人"
                            :label-width="formLabelWidth"
                            prop="leader_id"
                        >
                            <el-select v-model="distributeForm.leader_id">
                                <el-option
                                    v-for="item in headJson"
                                    :key="item.user_id"
                                    :label="item.user_name"
                                    :value="item.user_id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="巡检人员" :label-width="formLabelWidth" prop="worker_ids">
                            <el-select v-model="distributeForm.worker_ids" multiple>
                                <el-option
                                    v-for="item in membersJson"
                                    :key="item.user_id"
                                    :label="item.user_name"
                                    :value="item.user_id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="巡检时间"
                            :label-width="formLabelWidth"
                            style="width: 100%"
                            prop="plan_inspection_time"
                        >
                            <el-date-picker
                                v-model="distributeForm.plan_inspection_time"
                                align="right"
                                type="datetime"
                                :clearable="false"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                format="yyyy-MM-dd HH:mm:ss"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="distributeDialogVisible = false" class="leader-common-button">取消</el-button>
                <el-button
                    class="leader-common-button"
                    @click="distributeFormCommit('distributeForm')"
                    :loading="this.$store.state.btnType"
                >保存</el-button>
            </div>
        </el-dialog>
        <!-- 延期 -->
        <el-dialog
            class="leader-dialog"
            title="延期"
            :visible.sync="yanqiDialogVisible"
            :close-on-click-modal="false"
            width="800px"
        >
            <el-form
                class="leader-style-form"
                :rules="yanqiFormRules"
                :model="yanqiForm"
                ref="yanqiForm"
                :show-message="false"
            >
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item
                            label="巡检时间"
                            :label-width="formLabelWidth"
                            style="width: 100%"
                            prop="plan_inspection_time"
                        >
                            <el-date-picker
                                v-model="yanqiForm.plan_inspection_time"
                                align="right"
                                type="datetime"
                                :clearable="false"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                format="yyyy-MM-dd HH:mm:ss"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="yanqiDialogVisible = false" class="leader-common-button">取消</el-button>
                <el-button
                    class="leader-common-button"
                    @click="yanqiFormCommit()"
                    :loading="this.$store.state.btnType"
                >保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Pagination from '@/comon/components/pagination.vue';
import AddDefentDialog from '../defect_manage/components/add_defent_dialog';
import * as api from '../api/index';
export default {
    name: 'Main',
    components: {
        Pagination,
        AddDefentDialog,
    },
    data() {
        return {
            tableJson: [],
            defentDialogVisible: false,
            distributeDialogVisible: false,
            yanqiDialogVisible: false,
            recordshow: false,
            typeRecordShow: false,
            formLabelWidth: '140px',
            checkStrictly: true,
            recordForm: {
                inspection_place: '',
                leader_id_name: '',
                worker_names: '',
                inspection_time_start: '',
                inspection_time_end: '',
                inspection_result: '',
            },
            distributeForm: {
                leader_id: '',
                worker_ids: '',
                plan_inspection_time: '',
            },
            yanqiForm: {
                plan_inspection_time: '',
            },
            tableData: [],
            tableJiluData: [],
            inspection_task_tree_id: '',
            delQx: false,
            searchForm: {
                leader_id_name: '',
                inspection_plan_state: '',
                plan_inspection_time_range: '',
                // start_show_day: '',
                // end_show_day: '',
            },
            // 分页器数据
            paginationData: {
                pageNum: 1,
                pageSize: 10,
                totalNum: '',
            },
            typeRecordParam: {
                inspection_task_tree_id: '',
                typeInfoList: [],
            },
            defaultProps: {
                children: 'childlist',
                label: 'user_name',
            },
            formRules: {
                inspection_result: [
                    {
                        required: true,
                        trigger: 'blue',
                    },
                ],
                inspection_time_start: [
                    {
                        required: true,
                        trigger: 'blue',
                    },
                ],
                inspection_time_end: [
                    {
                        required: true,
                        trigger: 'blue',
                    },
                ],
            },
            distributeFormRules: {
                leader_id: [
                    {
                        required: true,
                        trigger: 'change',
                    },
                ],
                worker_ids: [
                    {
                        required: true,
                        trigger: 'blur',
                    },
                ],
                plan_inspection_time: [
                    {
                        required: true,
                        trigger: 'change',
                    },
                ],
            },
            yanqiFormRules: {
                plan_inspection_time: [
                    {
                        required: true,
                        trigger: 'change',
                    },
                ],
            },
        };
    },
    methods: {
        doSearch() {
            this.getTable();
        },
        doRecord(row) {
            this.recordshow = true;
            this.$nextTick(() => {
                this.$refs['recordForm'].resetFields();
                this.tableData = [];
            });
            const param = { inspection_task_id: row.inspection_task_id };
            api.selectTaskTree(param).then((res) => {
                if (res && res.error_code == '0') {
                    this.recordForm = res.bus_json;
                    if (res.bus_json.defectInf)
                        this.tableData = [res.bus_json.defectInfo];
                    this.tableJiluData = res.bus_json.opePlanInfoList;
                }
            });
        },
        doYanqi(row) {
            this.yanqiForm.inspection_task_id = row.inspection_task_id;
            this.yanqiForm.plan_inspection_time = row.plan_inspection_time;
            this.yanqiDialogVisible = true;
        },
        doDistribute(row) {
            // this.$nextTick(() => {
            //     this.$refs["distributeForm"].resetFields();
            // });
            const worker_ids_arr = row.worker_ids.split(',');
            this.distributeForm.leader_id = row.leader_id;
            this.distributeForm.worker_ids = [...worker_ids_arr];
            this.distributeForm.plan_inspection_time = row.plan_inspection_time;
            this.distributeForm.inspection_task_id = row.inspection_task_id;
            this.distributeDialogVisible = true;
        },
        doQuexian() {
            this.defentDialogVisible = true;
        },
        doTypeRecord(row) {
            this.typeRecordShow = true;
            this.inspection_task_tree_id = row.inspection_task_tree_id;
            const typeInfoList = [];
            const typeRecordParam = {
                inspection_task_tree_id: row.inspection_task_tree_id,
                typeInfoList: typeInfoList,
            };
            this.tableJiluData.forEach((item) => {
                if (
                    item.inspection_task_tree_id ==
                    row.inspection_task_tree_id &&
                    item.typeInfoList &&
                    item.typeInfoList.length
                ) {
                    item.typeInfoList.forEach((item_type) => {
                        typeInfoList.push({
                            tree_name: item.tree_name,
                            item_name: item_type.item_name,
                            item_content: item_type.item_content,
                            is_normal: item_type.is_normal
                                ? item_type.is_normal
                                : '0',
                            remark: item_type.remark,
                            inspection_tree_type_id:
                                item_type.inspection_tree_type_id,
                        });
                    });
                }
            });
            this.typeRecordParam = typeRecordParam;
        },
        typeRecordCommit() {
            api.insertTaskResult(this.typeRecordParam).then((res) => {
                if (res && res.error_code == '0') {
                    this.$message({
                        type: 'success',
                        message: '操作成功！',
                    });
                    this.typeRecordShow = false;
                    const param = {
                        inspection_task_id: this.recordForm.inspection_task_id,
                    };
                    api.selectTaskTree(param).then((res) => {
                        if (res && res.error_code == '0') {
                            this.tableJiluData = res.bus_json.opePlanInfoList;
                        }
                    });
                }
            });
        },
        deleteQx(row) {
            this.$confirm('确定删除这条记录？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    this.tableData = [];
                    this.delQx = true;
                    const param = {
                        inspection_task_id: this.recordForm.inspection_task_id,
                    };
                    api.selectTaskTree(param).then((res) => {
                        if (res && res.error_code == '0') {
                            this.tableJiluData = res.bus_json.opePlanInfoList;
                        }
                    });
                })
                .catch(() => { });
        },
        recordcommit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const param = {
                        inspection_task_id: this.recordForm.inspection_task_id,
                        inspection_time_start: this.recordForm
                            .inspection_time_start,
                        inspection_time_end: this.recordForm
                            .inspection_time_end,
                        inspection_result: this.recordForm.inspection_result,
                        inspection_task_state: '20',
                    };
                    if (this.delQx) param.defect_id = null;
                    api.updateTaskInfo(param).then((res) => {
                        if (res && res.error_code == '0') {
                            this.$message({
                                type: 'success',
                                message: '操作成功！',
                            });
                            this.recordshow = false;
                            this.getTable();
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        distributeFormCommit() {
            this.$refs['distributeForm'].validate((valid) => {
                if (valid) {
                    let worker_ids_str = '';
                    this.distributeForm.worker_ids.forEach((item) => {
                        worker_ids_str += item + ',';
                    });
                    const param = {
                        inspection_task_id: this.distributeForm
                            .inspection_task_id,
                        leader_id: this.distributeForm.leader_id,
                        plan_inspection_time: this.distributeForm
                            .plan_inspection_time,
                        worker_ids: worker_ids_str.substring(
                            0,
                            worker_ids_str.length - 1
                        ),
                    };
                    api.updateTaskInfo(param).then((res) => {
                        if (res && res.error_code == '0') {
                            this.$message({
                                type: 'success',
                                message: '操作成功！',
                            });
                            this.distributeDialogVisible = false;
                            this.getTable();
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        yanqiFormCommit() {
            this.$refs['yanqiForm'].validate((valid) => {
                if (valid) {
                    const param = {
                        ...this.yanqiForm,
                    };
                    api.updateTaskInfo(param).then((res) => {
                        if (res && res.error_code == '0') {
                            this.$message({
                                type: 'success',
                                message: '操作成功！',
                            });
                            this.yanqiDialogVisible = false;
                            this.getTable();
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                if (rowIndex % this.typeRecordParam.typeInfoList.length === 0) {
                    return {
                        rowspan: this.typeRecordParam.typeInfoList.length,
                        colspan: 1,
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    };
                }
            }
        },
        getTable() {
            const param = {
                ...this.searchForm,
                start_show_day: this.searchForm.plan_inspection_time_range[0],
                end_show_day: this.searchForm.plan_inspection_time_range[1],
                pageNum: this.paginationData.pageNum,
                pageSize: this.paginationData.pageSize,
            };
            api.selectTaskListByPage(param).then((res) => {
                if (res) {
                    this.tableJson = res.bus_json.items;
                    this.paginationData.pageNum = res.bus_json.pageNum;
                    this.paginationData.pageSize = res.bus_json.pageSize;
                    this.paginationData.totalNum = res.bus_json.totalNum;
                }
            });
        },
        paginationDataNew(sth) {
            this.paginationData = sth;
            this.getTable();
        },
        getMembers() {
            this.$axios
                .post(
                    '/operation/group/getGroupUsers',
                    {},
                    {
                        headers: {
                            token: window.localStorage.getItem('token'),
                            "Content-Type": "application/json"
                        },
                    }
                )
                .then((res) => {
                    if (res.data.error_code == 0) {
                        this.headJson = res.data.bus_json;
                        this.membersJson = res.data.bus_json;
                        // this.common.setToken(res.token);
                    } else if (res.data.error_code == -1) {
                        this.$router.push({
                            path: '/login',
                        });
                        // const h = this.$createElement;
                        // this.$notify({
                        //     title: '提示',
                        //     message: h(
                        //         'i',
                        //         { style: 'color: teal' },
                        //         res.error_msg
                        //     ),
                        // });
                    } else {
                        // const h = this.$createElement;
                        // this.$notify({
                        //     title: '提示',
                        //     message: h(
                        //         'i',
                        //         { style: 'color: teal' },
                        //         res.error_msg
                        //     ),
                        // });
                    }
                });
        },
    },
    mounted() {
        this.getTable();
        this.getMembers();
    },
};
</script>
<style lang="scss">
.patrol_task_container {
    // .inner-text {
    //     @include font_color;
    // }
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    .table-wrap {
        width: 100%;
        height: 700px;
    }
    .el-date-editor .el-range-input {
        background-color: transparent;
    }
    .el-date-editor .el-range-input {
        color: #fff !important;
    }
    .el-form-item__content {
        color: #fff;
        line-height: 46px;
    }
    .patrol_record_title {
        color: #fff;
        font-size: 16px;
        padding: 10px 0;
    }
    .leader-dialog .el-form-item {
        margin-bottom: 10px !important;
    }
    .leader-common-button {
        width: auto;
    }
    .el-radio {
        color: #fff;
    }
}
</style>
